<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire>
    <div class="check-list-form">
      <div class="content-type">
        <span>Registration Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p class="heavy-text">Priority of Service</p>
        <div class="form-note-section">
          <div class="icon-box"><i class="fas fa-exclamation fa-4x"></i></div>
          <div class="note-text">
            Please provide registration information.
          </div>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you an active member of the Military or a Veteran?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.ActiveMemberOfTheMilitary'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.activeMemberOfTheMilitary"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you the spouse or caregiver of an active member of the Military or a Veteran?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.SpouseOfAnActiveMemberOfTheMilitary'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.spouseOfAnActiveMemberOfTheMilitary"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you been supported through the State's Foster Care System?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.SupportedThroughTheStateFosterCareSystem'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.supportedThroughTheStateFosterCareSystem"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Do you consider yourself to be a Migrant Seasonal Farmer?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.MigrantSeasonalFarmer'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.migrantSeasonalFarmer"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Do you wish to disclose a disability?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.DiscloseDisability'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.discloseDisability"
                  class="ml-4"
                >
                  <el-row><el-radio :label="0" size="large">Yes, I have a disability I wish to disclose</el-radio></el-row>
                  <el-row style="margin-top: 10px"><el-radio :label="1" size="large">No, I do not have a disability</el-radio></el-row>
                  <el-row style="margin-top: 10px"><el-radio :label="2" size="large">I do not wish to answer</el-radio></el-row>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Do you have an annual household income below the federal poverty line?
              </label>
            </div>
          </el-row>
        </div>
        <div class="form-note-section" style="height: 135px !important;">
          <div class="icon-box"><i class="fas fa-exclamation fa-4x"></i></div>
          <div class="note-text-small" style="display: unset !important;">
            <p>Federal Poverty Lines are the same in 48 of the 50 states. The two exceptions are Alaska and Hawaii, which have a higher Federal Poverty Levels due to the higher cost of living. In 2023 the annual Federal Poverty Line for an individual in Alaska is $18,210, in Hawaii it is $16,770 and in the remainder of the states it is $14,580 (2023). For more information <a href='https://aspe.hhs.gov/topics/poverty-economic-mobility/poverty-guidelines' target="_blank">click here</a> </p>
          </div>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'PriorityOfService.AnnualHouseholdIncome'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.priorityOfService.annualHouseholdIncome"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col :span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { RegistrationQuestionnaire, TSLoading },
  data(){
    return{
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        disability: {
          discloseDisability: null
        },
        militaryMemberSpouse: {
          discloseDisability: null
        }
      },
      priorityOfServiceEmpty: {
        activeMemberOfTheMilitary: null,
        spouseOfAnActiveMemberOfTheMilitary: null,
        supportedThroughTheStateFosterCareSystem: null,
        migrantSeasonalFarmer: null,
        discloseDisability: null,
        annualHouseholdIncome: null,
      },
      jobSeekerId: null,
    }
  },
  computed: {
    skipStepTwo() {
      return this.registrationAnswer.priorityOfService.activeMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.spouseOfAnActiveMemberOfTheMilitary === 1 &&
        this.registrationAnswer.priorityOfService.discloseDisability === 1;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        this.registrationAnswer = res;
        this.registrationAnswer.priorityOfService = this.registrationAnswer.priorityOfService === null 
          ? this.priorityOfServiceEmpty 
          : this.registrationAnswer.priorityOfService;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    updateRegistrationAnswers() {
      this.isLoading = true;
      
      let command = null;
      if (this.registrationAnswer.jobSeekerId === null || this.registrationAnswer.jobSeekerId === undefined) {
        command = "jobseeker/addRegistrationAnswer";
        this.registrationAnswer.jobSeekerId = this.jobSeekerId;
      } else {
        this.registrationAnswer.validatePageType = 1;
        command = "jobseeker/updateRegistrationAnswer";
      }

      if(this.registrationAnswer.disability == null || this.registrationAnswer.disability == undefined) {
        this.registrationAnswer.veteranInfo = {};
        this.registrationAnswer.veteranInfo.discloseDisability =
          this.registrationAnswer.priorityOfService.discloseDisability;
      }

      if(this.registrationAnswer.militaryMemberSpouse == null || this.registrationAnswer.militaryMemberSpouse == undefined) {
        this.registrationAnswer.militaryMemberSpouse = {};
        this.registrationAnswer.militaryMemberSpouse.discloseDisability =
          this.registrationAnswer.priorityOfService.discloseDisability;
      }      

      this.$store
        .dispatch(command, this.registrationAnswer)
        .then(res => {
          if (res) {
            if (this.skipStepTwo) {
              this.$confirm(
                `Step 2 will be skipped based on the answers that you have provided.`,
                "Information",
                {
                  confirmButtonText: "Ok",
                  showCancelButton: false,
                  type: "info",
                  dangerouslyUseHTMLString: true,
                  center: true,
                  showClose: false,
                  closeOnClickModal: false
                }
              ).then(() => {
                this.$router.push({ name: "RegistrationQuestionnaireThree" });
              });
            } else {
              this.$router.push({ name: "RegistrationQuestionnaireTwo" });
            }
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>

.fa-4x{
  color: #004085;
}

</style>